<template>
  <div class="taolimenulist">
    <div class="menu1 flex_start">
      <div
        class="menu1item"
        v-for="(item, index) in menulist"
        :key="index"
        @mouseover="cptag(index)"
        @click="tojump(item)"
        :class="{ menu1itemactive: menuactive == index }"
      >
        {{ item.cat_name }}
      </div>
    </div>
    <div class="menu2 flex_start">
      <div
        class="menu2item"
        v-for="(item, index) in menulist"
        :key="index"
        :class="{ menu2active: menuactive == index }"
      >
        <div
          class="mu2childitem"
          v-for="(childitem, childindex) in item.children"
          :key="childindex"
          @click="tojump(childitem)"
        >
          {{ childitem.cat_name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menulist: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    menuactive: 0,
  }),
  methods: {
    cptag(index) {
      this.menuactive = index;
    },
     tojump(item) {
        this.$router.push({
          path: '/jpcol/tiaoli/tiaoliifyul',
          query:{
            id:item.id
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.taolimenulist {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0px 2px 15px 0px rgba(1, 1, 1, 0.1);
  .menu1 {
    font-size: 20px;
    border-bottom: 2px solid #0465ea;
    .menu1item {
      width: 135px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      color: #000000;
      cursor: pointer;
      &.menu1itemactive {
        color: #ffffff;
        background: #0465ea;
      }
    }
  }
  .menu2 {
    align-items: flex-start;
    .menu2item {
      width: 135px;
      height: 480px;
      padding-top: 14px;
      .mu2childitem {
        width: 135px;
        height: 49px;
        line-height: 49px;
        text-align: center;
        cursor: pointer;
        &:hover {
          background: #f7f7f7;
          color: #0465ea;
          border-radius: 30px;
        }
      }
      &.menu2active {
        background: #f7f7f7;
      }
    }
  }
}
</style>